export const tr = {
    'regions-transform-error-for-none-groups': 'Gösterim bölgeleri düzenlenecek hiçbir reklam grubu seçilmedi',
    'regions-transform-full-error-many': 'Gösterim bölgelerindeki değişiklikler seçilen gruplara uygulanamadı',
    'regions-transform-full-error-one': 'Gösterim bölgelerindeki değişiklikler seçilen gruba uygulanamadı',
    'regions-transform-full-success-many': 'Gösterim bölgelerindeki değişiklikler seçilen gruplara uygulandı',
    'regions-transform-full-success-one': 'Gösterim bölgelerindeki değişiklikler seçilen gruba uygulandı',
    'regions-transform-hint-count-campaigns': {
        one: 'Toplam {count} kampanya seçildi. Değişiklikler bu kampanyadaki tüm reklam gruplarına uygulanacak.',
        some: 'Toplam {count} kampanya seçildi. Değişiklikler bu kampanyalardaki tüm reklam gruplarına uygulanacak.',
        many: '{count} kampanya seçildi. Değişiklikler bu kampanyalardaki tüm reklam gruplarına uygulanacak.',
        none: 'Toplam {count} kampanya seçildi.'
    },
    'regions-transform-partial-success': {
        one: 'Gösterim bölgelerindeki değişiklikler {total} reklam grubundan {count} adedine uygulandı',
        some: 'Gösterim bölgelerindeki değişiklikler {total} reklam grubundan {count} adedine uygulandı',
        many: 'Gösterim bölgelerindeki değişiklikler {total} reklam grubundan {count} adedine uygulandı',
        none: 'Gösterim bölgelerindeki değişiklikler {total} reklam grubundan {count} adedine uygulandı'
    },
    'regions-transform-partial-success-with-link': {
        one:
            'Gösterim bölgelerindeki değişiklikler {total} reklam grubundan {count} adedine uygulandı, diğer gruplar için başarısız oldu.',
        some:
            'Gösterim bölgelerindeki değişiklikler {total} reklam grubundan {count} adedine uygulandı, diğer gruplar için başarısız oldu.',
        many:
            'Gösterim bölgelerindeki değişiklikler {total} reklam grubundan {count} adedine uygulandı, diğer gruplar için başarısız oldu.',
        none:
            'Gösterim bölgelerindeki değişiklikler {total} reklam grubundan {count} adedine uygulandı, diğer gruplar için başarısız oldu.'
    }
};
